// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OcoC","placeholdersHeader":"styles_placeholdersHeader__r7JhC","editorStyle":"styles_editorStyle__30uzG","placeholdersBox":"styles_placeholdersBox__1JYYb"};